import React from 'react';
import styled from 'styled-components';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import { formatTempo } from '../utils/formatters';

const TempoMedioForaJanelaCard = ({
  data,
  loading
}) => {
  const segundos = data?.tempoMedioForaJanelaSegundos;
  const temValor = segundos !== null && segundos !== undefined && Number.isFinite(Number(segundos));

  return (
    <Card>
      <CardBody>
        <CardTitle>Tempo médio fora da janela</CardTitle>
        <CardSubhead>Tempo médio das chegadas fora da janela até o início da contagem</CardSubhead>

        <ValueArea>
          {loading ? (
            <EmptyState>Carregando metricas...</EmptyState>
          ) : (
            <BigValue data-testid="tempo-medio-fora-janela-valor">
              {temValor ? formatTempo(segundos) : '-'}
            </BigValue>
          )}
        </ValueArea>
      </CardBody>
    </Card>
  );
};

const ValueArea = styled.div`
  min-height: 270px;
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BigValue = styled.div`
  color: #087f98;
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
`;

const EmptyState = styled.div`
  width: 100%;
  height: 270px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  background: #f8f9fa;
  border: 1px dashed #d8dde3;
`;

export default TempoMedioForaJanelaCard;
